import React from 'react';
import { useSettings } from '@/shared/contexts/SettingsContext';

interface LoadingScreenProps {
    message?: string;
    fullScreen?: boolean;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
    message,
    fullScreen = true
}) => {
    const { t } = useSettings();

    const content = (
        <div className="flex flex-col items-center justify-center gap-8 animate-fade-in">
            {/* Logo Container */}
            <div className="relative">
                {/* Pulsing ring */}
                <div className="absolute inset-0 bg-indigo-500/20 rounded-2xl blur-xl animate-pulse" />

                {/* Logo Box */}
                <div className="relative w-24 h-24 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-2xl shadow-indigo-500/30">
                    <span className="text-white font-bold text-5xl">V</span>
                </div>

                {/* Floating dots decoration */}
                <div className="absolute -top-4 -right-4 w-8 h-8 bg-purple-200 dark:bg-purple-900/50 rounded-full blur-lg animate-float" />
                <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-indigo-200 dark:bg-indigo-900/50 rounded-full blur-lg animate-float" style={{ animationDelay: '1.5s' }} />
            </div>

            {/* Text Content */}
            <div className="text-center space-y-3">
                <h2 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white">
                    VoxPop<span className="text-indigo-600 dark:text-indigo-400">AI</span>
                </h2>
                <p className="text-slate-500 dark:text-slate-400 font-medium animate-pulse">
                    {message || t('loading')}
                </p>
            </div>
        </div>
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-50 dark:bg-slate-950 transition-colors duration-300">
                {content}
            </div>
        );
    }

    return (
        <div className="w-full h-full min-h-[400px] flex items-center justify-center bg-slate-50 dark:bg-slate-950 rounded-3xl">
            {content}
        </div>
    );
};
